import Footer from '../../Components/Footer';
import Navbar from '../../Components/Navbar';
import SearchResults from '../../Components/Search bars/Searchresults';
import Landingpage from '../Home/Landingpage';


export default function Searchpage() {

    return(<>
    <Navbar />
    <Landingpage />
    <SearchResults />
    <Footer />
    </>);
}